import React from 'react';
import '../../styles/icone.css';
import IconaSport from './IconaSport';
import {codicePaese, bandieraEmoji} from './icone';

/**
 * La bandiera di una categoria — o, se la categoria non e' un paese,
 * l'icona del suo sport.
 *
 * Il codice paese arriva dal catalogo (campo `paese`, due lettere). Dal
 * nome non si ricava: "Germania" oggi, "Germany" domani, e i nomi
 * cambiano con la lingua del sito.
 *
 * Tre passi, dal migliore al peggiore:
 *   1. /assets/bandiere/<codice>.svg — il disegno vero, se il file c'e';
 *   2. l'emoji della bandiera, ricavata dal codice: nessun file, vale
 *      per ogni paese, e su telefono (dove sta la gran parte dei
 *      clienti) si vede benissimo;
 *   3. l'icona dello sport, quando il paese non c'e' — che e' il caso
 *      giusto per NBA, NHL, Euroleague, MLB e le coppe UEFA.
 */
class Bandiera extends React.Component {
  constructor(props) {
    super(props);
    /* Il file c'e' o non c'e': lo dice il browser quando prova a
       caricarlo. Niente elenco di file da tenere aggiornato a mano. */
    this.state = {senzaFile: false};
  }

  componentDidUpdate(prev) {
    if (prev.categoria !== this.props.categoria) {
      this.setState({senzaFile: false});
    }
  }

  render() {
    const {categoria, sport, className} = this.props;
    const codice = codicePaese(categoria);
    const classi = 'lvc-bandiera' + (className ? ' ' + className : '');
    const nome = (categoria && categoria.name) || '';

    if (!codice) {
      return <IconaSport sport={sport} className={className} title={nome}/>;
    }

    if (this.state.senzaFile) {
      return (
        <span className={classi + ' emoji'} role={'img'} aria-label={nome}>
          {bandieraEmoji(codice)}
        </span>
      );
    }

    return (
      <img
        src={'/assets/bandiere/' + codice + '.svg'}
        alt={nome}
        className={classi}
        onError={() => this.setState({senzaFile: true})}
      />
    );
  }
}

export default Bandiera;
